import _ from './app-header.module.scss'
import React from 'react'
import {Flex} from './flex'
import {Logo, Symbol} from './brand'
import {Container} from './container'
import {$, $$$} from '../shared/class-name'
import {useLocation} from 'react-router-dom'
import {isProfilePath} from '../apps/outof195/shared/profile-url'
import {useIsMobile} from '../hooks/use-is-mobile'
import {getAppLogoVisible} from '../shared/layout-dynamics'
import {isLoggedIn} from '../shared/session'

export const AppHeader = ({className, children, leftTemplate, rightTemplate}) => {
    const {pathname} = useLocation()
    const isMobile = useIsMobile()
    return <Container><div className={$$$(_.root, $(_.hidden, isProfilePath(pathname)))}>
        <Flex row style={{position: 'relative', height: '100%'}}>
            <div className={_.leftTemplate}>{leftTemplate}</div>
            {getAppLogoVisible(pathname, {isMobile}) && <Symbol secondary size={'72px'}
                // children={<>{!!isLoggedIn() && <Logo size={8} primary/>}</>}
            />}
            <div className={_.rightTemplate}>{rightTemplate}</div>
        </Flex>
    </div></Container>
}
